import get from 'lodash/get';

import { MissingTranslationError } from '../shared/errors';
import type { Replacements, TranslationKeyArg, Translations } from '../shared/types';
import type { UsedTranslationsTracker } from '../UsedTranslationsTracker';

import { replace } from './replace';

export function translate(
	{
		translations,
		tracker,
	}: {
		translations: readonly Translations[];
		tracker?: UsedTranslationsTracker;
	},
	key: TranslationKeyArg,
	replacements: Replacements | undefined,
): string {
	const value = translations.reduce<string | Translations | null>(
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		(acc, dic) => acc ?? get(dic, key as string) ?? null,
		null,
	);
	if (typeof value !== 'string') {
		throw new MissingTranslationError({ key: key as string });
	}
	tracker?.add(key, value);
	return replace(key, value, replacements);
}
